import React from "react";
import {Redirect} from "react-router-dom";
import {RouteInterface} from "../interfaces/RouteInterface";
import {RouteDefine} from "./RouteDefine";
import {Integrate} from "../features/private/Integrate";
import {Business} from "../features/private/Business";
import Invoice from "../features/private/Log/Invoice";
import Stripe from "../features/private/Stripe";
import Payment from "../features/private/Log/payment";
import Payout from "../features/private/Log/payout";
import Subscription from "../features/private/Log/subscription";
import Refund from "../features/private/Log/refund";
import ProductGroup from "../features/private/Settings/ProductGroup";
import Dashboard from "../features/private/Dashboard";
import Schedule from "../features/private/Settings/Schedule";
import SettingsOverview from "../features/private/Settings/Overview";
import Help from "../features/private/Help";
import {withSettingsLayout} from "./withSettingsLayout";
import {LegacySettingsRedirect} from "./LegacySettingsRedirect";
import {LegacyEconomicRoute, SettingsEconomicRoute} from "./SettingsEconomicRoute";
import {getSyncEngineVersion} from "../common/helpers/syncEngine";

const SettingsOverviewPage = withSettingsLayout(SettingsOverview);
const SettingsBusiness = withSettingsLayout(Business);
const SettingsStripe = withSettingsLayout(Stripe);
const SettingsSchedule = withSettingsLayout(Schedule);
const SettingsProductGroup = withSettingsLayout(ProductGroup);

/** Product group is not ready for V2 — redirect to settings hub. */
const SettingsProductGroupRoute: React.FC = () => {
    if (getSyncEngineVersion() === "v2") {
        return <Redirect to={RouteDefine.settings}/>;
    }
    return <SettingsProductGroup/>;
};

/** Help is V2-only. */
const HelpRoute: React.FC = () => {
    if (getSyncEngineVersion() !== "v2") {
        return <Redirect to={RouteDefine.dashboard}/>;
    }
    return <Help/>;
};

const SettingsIndex = SettingsOverviewPage;

const LegacyBusinessRedirect = () => (
    <LegacySettingsRedirect to={RouteDefine.settingsBusiness}/>
);

const LegacyStripeRedirect = () => (
    <LegacySettingsRedirect to={RouteDefine.settingsStripe}/>
);

export const privateRoute: Array<RouteInterface> = [
    {path: RouteDefine.dashboard, Component: Dashboard},

    {path: RouteDefine.integrate, Component: Integrate},
    {path: RouteDefine.help, Component: HelpRoute},

    {path: RouteDefine.settings, Component: SettingsIndex},
    {path: RouteDefine.settingsBusiness, Component: SettingsBusiness},
    {path: RouteDefine.settingsEconomic, Component: SettingsEconomicRoute},
    {path: RouteDefine.settingsStripe, Component: SettingsStripe},
    {path: RouteDefine.settingsSchedule, Component: SettingsSchedule},
    {path: RouteDefine.settingsProductGroup, Component: SettingsProductGroupRoute},

    {path: RouteDefine.business, Component: LegacyBusinessRedirect},
    {path: RouteDefine.economic, Component: LegacyEconomicRoute},
    {path: RouteDefine.stripe, Component: LegacyStripeRedirect},

    {path: RouteDefine.invoice, Component: Invoice},
    {path: RouteDefine.payment, Component: Payment},
    {path: RouteDefine.payout, Component: Payout},
    {path: RouteDefine.subscription, Component: Subscription},
    {path: RouteDefine.refund, Component: Refund},
];
